(ns rlws.iot-cloud.frontend.account
  (:require [re-frame.core :as rf]
            [tick.alpha.api :as t]
            [rlws.iot-cloud.frontend.subscriptions :as sub]
            [rlws.iot-cloud.frontend.events :as events]
            [clojure.string :as str]
            [rlws.iot-cloud.frontend.site :as site]
            [rlws.iot-cloud.frontend.components :as components]))

(defn info []
  (let [user @(rf/subscribe [::sub/current-user])]
    [:<>
     [:h1.text-lg.margin-bottom-sm
      "Profile Settings"]
     [:div.account-settings
      [:div.account-settings__item
       [:div.item__label "Name:"]
       [:div.item__value (:name user)]]
      [:div.account-settings__item
       [:div.item__label "Username:"]
       [:div.item__value (:username user)]]
      [:div.account-settings__item
       [:div.item__label "Email:"]
       [:div.item__value (:email user)]]
      [:div.account-settings__item
       [:div.item__label "Roles:"]
       [:div.item__value
        [:span
         (interpose
          ", "
          (for [role (:roles user)]
            role))]]]]]))

(defn last-edited-text [asset current-scale iqube timestamp user frequency message enabled]
  (let [frequency-info (get-in asset [:notifications (keyword (str (:id asset) " " current-scale " " (:ip iqube)))])]
    (try
      [:div {:style {:display "flex" :flex-direction "column"}}
       [:span {:style {:color "var(--grayscale-gray-80, #50545E)"
                       :font-feature-settings "'clig' off, 'liga' off"
                       :font-size "14px"
                       :font-style "normal"
                       :font-weight "400"
                       :line-height "20px"
                       :letter-spacing "0.2px"}}
        (str "Last edited at: " (str (t/inst (timestamp frequency-info))))]
       [:span {:style {:color "var(--grayscale-gray-80, #50545E)"
                       :font-feature-settings "'clig' off, 'liga' off"
                       :font-size "14px"
                       :font-style "normal"
                       :font-weight "400"
                       :line-height "20px"
                       :letter-spacing "0.2px"}}
        (str "\nBy: " (user frequency-info))]
       [:span {:style {:color "var(--grayscale-gray-80, #50545E)"
                       :font-feature-settings "'clig' off, 'liga' off"
                       :font-size "14px"
                       :font-style "normal"
                       :font-weight "400"
                       :line-height "20px"
                       :letter-spacing "0.2px"}}
        (str "\nCurrently set at " (frequency frequency-info) " hour" (when-not (= (frequency frequency-info) "1") "s") " " (when-not enabled "(Currently disabled)"))]]
      (catch js/Object e
        (.log js/console e)
        [:span {:style {:color "var(--grayscale-gray-80, #50545E)"
                        :font-feature-settings "'clig' off, 'liga' off"
                        :font-size "14px"
                        :font-style "normal"
                        :font-weight "400"
                        :line-height "20px"
                        :letter-spacing "0.2px"}}
         message]))))

(defn notification-settings []
  (let [cur-scale @(rf/subscribe [::sub/current-scale])
        scales @(rf/subscribe [::sub/complete-scales])
        iqube @(rf/subscribe [::sub/data :iqube])
        asset @(rf/subscribe [::sub/data :asset])
        current-scale @(rf/subscribe [::sub/data :scale])
        current-scale-number (:number current-scale)
        frequency @(rf/subscribe [::sub/current-scale-timeout])
        temp-frequency @(rf/subscribe [::sub/current-scale-temporary-timeout])
        checkbox @(rf/subscribe [::sub/current-scale-temporary-checkbox])
        enabled? (get-in asset [:notifications (keyword (str (:id asset) " " current-scale-number " " (:ip iqube))) :temp-enabled])
        submitting? @(rf/subscribe [::sub/submitting-notifications])
        intervals [1,2,3,6,12,24]
        user @(rf/subscribe [::sub/current-user])]
  [:div
   [:h1.text-lg.margin-bottom-sm
    "Notification Settings"]
   [:span.notification-text "Select a scale to set the frequency of notifications for:"]
   [:div.interval-dropdown
    [:select.form-control {:field :list :id :many.options
                           :on-change (fn [evt]
                                        (let [scale (-> evt .-target .-value)]
                                          (rf/dispatch [::events/set-current-scale (when-not (= scale "Select Scale") scale)])))}
     [:option "Select Scale"]
     (for [scale (sort-by :name #(compare (clojure.string/lower-case %1) (clojure.string/lower-case %2)) scales)]
       ^{:key scale}
       [:option {:value (str (:gateway scale) " " (site/to-plain-id scale) " " (:iqube scale))} (:name scale)])]]
   (when cur-scale
     (if (= cur-scale (site/to-plain-id current-scale))
       [:div
        [:span.notification-text
         "The standard default frequency for notifications is 1 hour. To change this, select a value below:"]
        [:div.interval-dropdown
         [:select.form-control {:field :list :id :many.options
                                :on-change (fn [evt]
                                             (let [scale-timeout (-> evt .-target .-value)]
                                               (rf/dispatch [::events/set-current-scale-timeout (when-not (= scale-timeout "Select Interval") scale-timeout)])))}
          [:option "Select Interval"]
          (for [interval intervals]
            ^{:key interval}
            [:option {:value interval} (str interval " Hour Interval")])]]
        [last-edited-text asset current-scale-number iqube :frequency-timestamp :user :frequency
         "Notification frequency has not been edited." true]
        [:div.dividing-line]
        [:div {:style {:display "flex"
                       :flex-direction "row"}}
         [:input {:type "checkbox"
                  :style {:align-self "flex-start"
                          :margin-top "5px"
                          :margin-right "10px"}
                  :on-change (fn [evt]
                               (rf/dispatch [::events/set-current-scale-temporary-checkbox (-> evt .-target .-checked)]))}]
         [:div {:style {:display "flex"
                        :flex-direction "column"
                        :margin-bottom "20px"}}
          [:span {:style {:color "var(--grayscale-gray-100, #202532)"
                          :font-feature-settings "'clig' off, 'liga' off"
                          :font-size "16px"
                          :font-style "normal"
                          :font-weight "400"
                          :line-height "24px"
                          :letter-spacing "0.2px"}} "Temporary Notification Change"]
          [:span {:style {:color "var(--grayscale-gray-80, #50545E)"
                          :font-feature-settings "'clig' off, 'liga' off"
                          :font-size "14px"
                          :font-style "normal"
                          :font-weight "400"
                          :line-height "20px"
                          :letter-spacing "0.2px"}} "This will reset after 7 days."]]]
        [:span.notification-text
         "The standard default frequency for notifications is 1 hour. To change this temporarily, select a value below:"]
        [:div.interval-dropdown
         [:select.form-control {:field :list :id :many.options
                                :disabled (not checkbox)
                                :on-change (fn [evt]
                                             (let [scale-timeout (-> evt .-target .-value)]
                                               (rf/dispatch [::events/set-current-scale-temporary-timeout (when-not (= scale-timeout "Select Interval") scale-timeout)])))}
          [:option "Select Interval"]
          (for [interval intervals]
            ^{:key interval}
            [:option {:value interval} (str interval " Hour Interval")])]]
        [last-edited-text asset current-scale-number iqube :temp-frequency-timestamp :temp-user :temp-frequency
         "Temporary notification frequency has not been edited." enabled?]
        [:div {:style {:display "flex" :gap "10px" :align-items "center"}}
         [:button.save-button {:disabled (or submitting? (and (nil? frequency) (or (nil? temp-frequency) (and (not (nil? temp-frequency)) (not checkbox)))))
                               :on-click (fn [] (rf/dispatch
                                                 [::events/put-data
                                                  (str "/api/assets/" (:id asset))
                                                  (cond-> asset
                                                    (nil? (get-in asset [:notifications (keyword (str (:id asset) " " current-scale-number " " (:ip iqube))) :frequency])) (assoc-in [:notifications (keyword (str (:id asset) " " current-scale-number " " (:ip iqube))) :frequency] "1")
                                                    (some? frequency) (assoc-in [:notifications (keyword (str (:id asset) " " current-scale-number " " (:ip iqube))) :frequency-timestamp] (str (t/instant)))
                                                    (some? frequency) (assoc-in [:notifications (keyword (str (:id asset) " " current-scale-number " " (:ip iqube))) :frequency] frequency)
                                                    (some? frequency) (assoc-in [:notifications (keyword (str (:id asset) " " current-scale-number " " (:ip iqube))) :user] (:username user))
                                                    (and checkbox (some? temp-frequency)) (assoc-in [:notifications (keyword (str (:id asset) " " current-scale-number " " (:ip iqube))) :temp-frequency] temp-frequency)
                                                    (and checkbox (some? temp-frequency)) (assoc-in [:notifications (keyword (str (:id asset) " " current-scale-number " " (:ip iqube))) :temp-frequency-timestamp] (str (t/instant)))
                                                    (and checkbox (some? temp-frequency)) (assoc-in [:notifications (keyword (str (:id asset) " " current-scale-number " " (:ip iqube))) :temp-user] (:username user))
                                                    (and checkbox (some? temp-frequency)) (assoc-in [:notifications (keyword (str (:id asset) " " current-scale-number " " (:ip iqube))) :temp-enabled] true)
                                                    true (assoc :crux.db/id (:id asset)))
                                                  [::events/modify-notifications-success "Added Notification Information" :assets asset]])
                                           (rf/dispatch [::events/set-submitting-notifications true]))}
          "Save"]
         (when (not (nil? enabled?))
           [:button.enable-button {:disabled submitting?
                                 :on-click (fn [] (rf/dispatch
                                                   [::events/put-data
                                                    (str "/api/assets/" (:id asset))
                                                    (cond-> asset
                                                      true (assoc-in [:notifications (keyword (str (:id asset) " " current-scale-number " " (:ip iqube))) :temp-enabled] (not enabled?))
                                                      true (assoc-in [:notifications (keyword (str (:id asset) " " current-scale-number " " (:ip iqube))) :temp-frequency-timestamp] (str (t/instant)))
                                                      true (assoc-in [:notifications (keyword (str (:id asset) " " current-scale-number " " (:ip iqube))) :temp-user] (:username user))
                                                      true (assoc :crux.db/id (:id asset)))
                                                    [::events/modify-notifications-success "Updated Notification Information" :assets asset]])
                                             (rf/dispatch [::events/set-submitting-notifications true]))}
            (if enabled? "Disable Temporary Notifications" "Enable Temporary Notifications")])]]
         [:div {:style {:margin "50px 125px"}} [components/loader]]))]))
